/* eslint-disable arrow-parens */
import moment from 'moment';
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import {
  GET_TEAM_WISE_CATEGORYLIST_GQL,
  SET_STORE_MAPPED_CATEGORIES_GQL,
  SET_STORE_UNMAPPED_CATEGORIES_GQL,
  GET_ACCOUNTINGCATEGORY_GQL,
  GET_ACTIVE_ACCOUNTING_SYSTEM_GQL,
  SET_ACCSYS_DISCONNECT_GQL,
  SET_UPDATE_MAPPED_CATEGORIES_GQL,
  GET_CLEARED_TRANSACTIONS_GQL,
  GET_SELECTED_CREDITCARD_ACC,
  GET_SELECTED_BANKACCOUNT_GQL,
  GET_CLEARED_BANK_TRANSACTIONS_GQL,
  GET_EXTERNAL_CARD_ACCOUNTS_GQL,
  GET_EXTERNAL_CARD_TRANSACTION_GQL,
  GET_SELECTED_PAYABLE_ACCOUNT_GQL,
  GET_ACCOUNTINGTAG_GQL,
  GET_ACCOUNTINGTEAM_GQL,
  SET_UPDATE_MAPPED_TAGS_GQL,
  SET_UPDATE_MAPPED_TEAMS_GQL,
  GET_TEAMS_FOR_MAPPING_GQL,
  SET_STORE_ACCOUNTING_TEAMS_GQL,
  SET_STORE_ACCOUNTING_TAGS_GQL,
  SET_STORE_TRANSACTION_SYNC_FREQUENCY_GQL,
  GET_TRANSACTION_SYNC_FREQUENCY_VALUE_GQL,
  GET_SYNC_TRANSACTION_HISTORY_GQL,
  GET_CHECK_PREVIOUS_OPERATION_STATUS_GQL,
  GET_CLUSTERED_COMPANIES_LIST_GQL,
  SET_STORE_DUE_ACCOUNTS_MAPPING_GQL,
  GET_ASSETS_LIABILITIES_LIST_GQL,
  GET_DUE_ACCOUNT_MAPPING_GQL,
  GET_ACCOUNTING_LIABILITY_GQL,
  GET_MOVED_TRANSACTIONS_GQL
} from '@/graphql/accounting.gql';


export default {
  namespaced: true,

  state: {
    teamWiseCategoryList: [],
    accountingCategoriesStore: null,
    accountingCategoryList: [],
    activeAccountingSys: null,
    accountingSysDisConnected: null,
    updatedMappedCategories: null,
    clearedTransactions: [],
    selectedCreditCardAccount: null,
    selectedBankAccount: null,
    clearedBankTransactions: null,
    externalCreditCardAccounts: null,
    selectedPayableAccount: null,
    accountingTags: null,
    accountingTeams: null,
    updatedMappedTags: null,
    updatedMappedTeams: null,
    teamsForMapping: [],
    accountingTeamsStore: null,
    accountingTagsStore: null,
    transactionSyncFrequencyStored: null,
    transactionSyncFrequencyValue: null,
    syncedTransactionHistory: null,
    previousOperationStatus: null,
    clusteredCompaniesList: [],
    storedDueAccountsMapping: null,
    assetsLiabilitiesList: [],
    dueAccountMapping: [],
    accountingLiabilityList: [],
    movedTransactionsList: null,
  },

  mutations: {
    GET_TEAM_WISE_CATEGORY_LIST(state, payload) {
      state.teamWiseCategoryList = payload;
    },
    SET_ACCOUNTING_CATEGORIES_STORE(state, payload) {
      state.accountingCategoriesStore = payload;
    },
    GET_ACCOUNTINGCATEGORY(state, payload) {
      state.accountingCategoryList = payload;
    },
    GET_ACTIVE_ACCOUNTING_SYSTEM(state, payload) {
      state.activeAccountingSys = payload;
    },
    SET_ACCSYS_DISCONNECT(state, payload) {
      state.accountingSysDisConnected = payload;
    },
    SET_UPDATE_MAPPED_CATEGORIES(state, payload) {
      state.updatedMappedCategories = payload;
    },
    GET_CLEARED_TRANSACTIONS(state, payload) {
      state.clearedTransactions = payload;
    },
    GET_SELECTED_CREDITCARD(state, payload) {
      state.selectedCreditCardAccount = payload;
    },
    GET_SELECTED_BANKACCOUNT(state, payload) {
      state.selectedBankAccount = payload;
    },
    GET_CLEARED_BANK_TRANSACTIONS(state, payload) {
      state.clearedBankTransactions = payload;
    },
    GET_EXTERNAL_CARD_ACCOUNTS(state, payload) {
      state.externalCreditCardAccounts = payload;
    },
    GET_EXTERNAL_CARD_TRANSACTIONS(state, payload) {
      state.clearedTransactions = payload;
    },

    GET_SELECTED_PAYABLE_ACCOUNT(state, payload) {
      state.selectedPayableAccount = payload;
    },
    GET_ACCOUNTINGTAG(state, payload) {
      state.accountingTags = payload;
    },
    GET_ACCOUNTINGTEAM(state, payload) {
      state.accountingTeams = payload;
    },
    SET_UPDATE_MAPPED_TAGS(state, payload) {
      state.updatedMappedTags = payload;
    },
    SET_UPDATE_MAPPED_TEAMS(state, payload) {
      state.updatedMappedTeams = payload;
    },
    GET_TEAMS_FOR_MAPPING(state, payload) {
      state.teamsForMapping = payload;
    },
    SET_STORE_ACCOUNTING_TEAMS(state, payload) {
      state.accountingTeamsStore = payload;
    },
    SET_STORE_ACCOUNTING_TAGS(state, payload) {
      state.accountingTagsStore = payload;
    },
    SET_STORE_TRANSACTION_SYNC_FREQUENCY(state, payload) {
      state.transactionSyncFrequencyStored = payload;
    },
    GET_TRANSACTION_SYNC_FREQUENCY_VALUE(state,payload) {
      state.transactionSyncFrequencyValue = payload;
    },
    GET_SYNC_TRANSACTION_HISTORY(state, payload) {
      state.syncedTransactionHistory = payload;
    },
    GET_CHECK_PREVIOUS_OPERATION_STATUS(state, payload) {
      state.previousOperationStatus = payload;
    },
    GET_CLUSTERED_COMPANIES_LIST(state, payload) {
      state.clusteredCompaniesList = payload;
    },
    SET_STORE_DUE_ACCOUNTS_MAPPING(state, payload) {
      state.storedDueAccountsMapping = payload;
    },
    GET_ASSETS_LIABILITIES_LIST(state, payload) {
      state.assetsLiabilitiesList = payload;
    },
    GET_DUE_ACCOUNT_MAPPING(state, payload) {
      state.dueAccountMapping = payload;
    },
    GET_ACCOUNTING_LIABILITY(state, payload) {
      state.accountingLiabilityList = payload;
    },
    GET_MOVED_TRANSACTIONS(state, payload) {
      state.movedTransactionsList = payload;
    }
  },

  actions: {
    async getTeamWiseCategoriesList({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: GET_TEAM_WISE_CATEGORYLIST_GQL,
          variables: {
            companyId: payload.companyId,
          },
        })
        .then(({ data }) => {
          const groupWiseCategoryList = [];
          data.groups.forEach((group) => {
            group.categories.forEach((category) => {
              let accCatCatId;
              if (category.accountingCategory) {
                if (category.accountingCategory.categoryIdStr) {
                  accCatCatId = category.accountingCategory.categoryIdStr;
                } else {
                  accCatCatId = category.accountingCategory.categoryId;
                }
              } else if (category.agillinkCategory) {
                accCatCatId = category.agillinkCategory.id;
              } else {
                accCatCatId = null;
              }

              const categoryObj = {
                name: category.categoryName,
                id: category.id,
                groupName: group.groupName,
                accCatCatId,
                recordStatus: category.recordStatus,
                companyCategoryId: (category.companyCategory) ? category.companyCategory.id : null,
              };

              groupWiseCategoryList.push(categoryObj);
            });
          });


          groupWiseCategoryList.sort((a, b) => a.recordStatus - b.recordStatus);
          console.log('groupWiseCategoryList', groupWiseCategoryList);
          commit('GET_TEAM_WISE_CATEGORY_LIST', groupWiseCategoryList);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async storeAccountingCategories({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      const { unmappedCategories } = payload;
      await apolloClient
        .mutate({
          mutation: SET_STORE_MAPPED_CATEGORIES_GQL,
          variables: {
            companyId: payload.companyId,
            quickBookTblId: payload.quickBookTblId,
            xeroTblId: payload.xeroTblId,
            agilLinkOnlineTblId: payload.agilLinkOnlineTblId,
            mappedAccCategoriesList: payload.mappedCategories,
            liabilityAccountsToBeStoredList: payload.liabilityAccountsToBeStored,
          },
        })
        .then(() => {
          apolloClient
            .mutate({
              mutation: SET_STORE_UNMAPPED_CATEGORIES_GQL,
              variables: {
                companyId: payload.companyId,
                quickBookTblId: payload.quickBookTblId,
                xeroTblId: payload.xeroTblId,
                agilLinkOnlineTblId: payload.agilLinkOnlineTblId,
                unmappedAccCategoriesList: unmappedCategories,
              },
            })
            .then((dataOne) => {
              console.log(dataOne);
              commit('SET_ACCOUNTING_CATEGORIES_STORE', dataOne.data);
              commit('shared/SET_LOADING', false, { root: true });
            })
            .catch((err) => {
              console.log(err);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getAccountingCategory({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_ACCOUNTINGCATEGORY_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          // This tweak applied because of AgilLink where we are showing template glaccounts at end of dropdown list
          const activeGLAccounts = [];
          const templateGLAccounts = [];
          if (data.accountingCategories.length > 0) {
            data.accountingCategories.forEach((accCategory) => {
              if (accCategory.isTemplate) {
                templateGLAccounts.push(accCategory);
              } else {
                activeGLAccounts.push(accCategory);
              }
            });
            data.accountingCategories = activeGLAccounts.concat(templateGLAccounts);
          }

          commit('GET_ACCOUNTINGCATEGORY', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getAccountingTag({ commit }, payload) {
      console.log('getAccountingTag');
      await apolloClient
        .query({
          query: GET_ACCOUNTINGTAG_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getAccountingTagData) => {
          console.log(getAccountingTagData);
          commit('GET_ACCOUNTINGTAG', getAccountingTagData.data.accountingTags);
        })
        .catch(getAccountingTagErr => {
          commit('GET_ACCOUNTINGTAG', { status: 'failure', error: getAccountingTagErr.message });
        });
    },
    async getAccountingTeam({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_ACCOUNTINGTEAM_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getAccountingTeamData) => {
          commit('GET_ACCOUNTINGTEAM', getAccountingTeamData.data.accountingTeams);
        })
        .catch(getAccountingTeamErr => {
          commit('GET_ACCOUNTINGTEAM', { status: 'failure', error: getAccountingTeamErr.message });
        });
    },
    async storeAllUnMappedCategories({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      const { unmappedCategories } = payload;
      await apolloClient
        .mutate({
          mutation: SET_STORE_UNMAPPED_CATEGORIES_GQL,
          variables: {
            companyId: payload.companyId,
            quickBookTblId: payload.quickBookTblId,
            xeroTblId: payload.xeroTblId,
            agilLinkOnlineTblId: payload.agilLinkOnlineTblId,
            unmappedAccCategoriesList: unmappedCategories,
          },
        })
        .then(({ data }) => {
          commit('SET_ACCOUNTING_CATEGORIES_STORE', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getActiveAccountingSys({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: GET_ACTIVE_ACCOUNTING_SYSTEM_GQL,
          variables: {
            companyId: payload.companyId,
          },
        })
        .then(({ data }) => {
          commit('GET_ACTIVE_ACCOUNTING_SYSTEM', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async disConnectAccountingSys({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient.mutate({
        mutation: SET_ACCSYS_DISCONNECT_GQL,
        variables: {
          quickBookTblId: payload.quickBookTblId,
          xeroTblId: payload.xeroTblId,
          agilLinkOnlineTblId: payload.agilLinkOnlineTblId,
          companyId: payload.companyId,
        },
      }).then((disConnectAccountingSysdata) => {
        commit('SET_ACCSYS_DISCONNECT', disConnectAccountingSysdata.data.disConnectAccountingSys);
        commit('shared/SET_LOADING', false, {
          root: true,
        });
      }).catch(disConnectAccountingSyserr => {
        console.log(disConnectAccountingSyserr);
        commit('shared/SET_LOADING', false, {
          root: true,
        });
      });
    },
    async updateMappedAccTags({ commit }, payload) {
      apolloClient.mutate({
        mutation: SET_UPDATE_MAPPED_TAGS_GQL,
        variables: payload,
      }).then((updateMappedAccTagsData) => {
        commit('SET_UPDATE_MAPPED_TAGS', updateMappedAccTagsData.data.updateMappedAccTags);
      }).catch(updateMappedAccTagsErr => {
        commit('SET_UPDATE_MAPPED_TAGS', { status: 'failure', error: updateMappedAccTagsErr.message });
      });
    },
    async updateMappedAccTeams({ commit }, payload) {
      apolloClient.mutate({
        mutation: SET_UPDATE_MAPPED_TEAMS_GQL,
        variables: payload,
      }).then((updateMappedAccTeamsData) => {
        commit('SET_UPDATE_MAPPED_TEAMS', updateMappedAccTeamsData.data.updateMappedAccTeams);
      }).catch(updateMappedAccTeamsErr => {
        commit('SET_UPDATE_MAPPED_TEAMS', { status: 'failure', error: updateMappedAccTeamsErr.message });
      });
    },
    async updateMappedAccCategories({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient.mutate({
        mutation: SET_UPDATE_MAPPED_CATEGORIES_GQL,
        variables: payload,
      }).then((updateMappedAccCategoriesdata) => {
        commit('SET_UPDATE_MAPPED_CATEGORIES', updateMappedAccCategoriesdata.data);
        commit('shared/SET_LOADING', false, {
          root: true,
        });
      }).catch(updateMappedAccCategorieserr => {
        console.log(updateMappedAccCategorieserr);
        commit('shared/SET_LOADING', false, {
          root: true,
        });
      });
    },
    async getClearedTransactions({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_CLEARED_TRANSACTIONS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getClearedTransactionsData) => {
          
            console.log(payload.companyId);
            let clearedTransactionsList = {userExpenses:[]};
            getClearedTransactionsData.data.userExpenses.forEach((clearedTransaction) => {
              if(clearedTransaction.accountingTransactionTempBackup
                && clearedTransaction.accountingTransactionTempBackup.companyId === payload.companyId) {
                    clearedTransaction.accountingTransactionTempBackup.receivingCompanyName =  clearedTransaction.Company.companyName;
                  clearedTransaction.accountingTransaction = clearedTransaction.accountingTransactionTempBackup;
                  if(clearedTransaction.accountingTransactionTempBackup.category) {
                    clearedTransaction.category = {categoryName: clearedTransaction.accountingTransactionTempBackup.category.categoryName};
                  }
                  clearedTransactionsList.userExpenses.push(clearedTransaction);
              } else {
                clearedTransaction.accountingTransactionTempBackup = null;
                if(clearedTransaction.recordStatus !== 9 
                  && clearedTransaction.category
                  && clearedTransaction.category.accountingCategory 
                  ) {
                  // Regular case
                  clearedTransactionsList.userExpenses.push(clearedTransaction);
                }
                if(clearedTransaction.recordStatus === 9 && clearedTransaction.accountingTransaction) {
                  // Soft deleted synced transaction
                  clearedTransactionsList.userExpenses.push(clearedTransaction);
                }
              }
            });
          
          commit('GET_CLEARED_TRANSACTIONS', clearedTransactionsList);
        })
        .catch(err => {
          console.log(err);
        });
    },
    async getSelectedCreditCardAccount({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_SELECTED_CREDITCARD_ACC,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          let accountingCreditCard = {};
          if (data.accountingCcAccs.length > 0) {
            accountingCreditCard = data.accountingCcAccs[0];
          }
          commit('GET_SELECTED_CREDITCARD', accountingCreditCard);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getSelectedCreditCardAccounterr => {
          console.log(getSelectedCreditCardAccounterr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async getSelectedBankAccount({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_SELECTED_BANKACCOUNT_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_SELECTED_BANKACCOUNT', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getSelectedBankAccounterr => {
          console.log(getSelectedBankAccounterr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async getClearedBankTransactions({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_CLEARED_BANK_TRANSACTIONS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_CLEARED_BANK_TRANSACTIONS', data);
        })
        .catch(getClearedBankTransactionserr => {
          console.log(getClearedBankTransactionserr);
        });
    },
    async getExternalCardAccounts({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_EXTERNAL_CARD_ACCOUNTS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((externalCardAccountsData) => {
          commit('GET_EXTERNAL_CARD_ACCOUNTS', externalCardAccountsData.data.getExternalCardAccounts);
        })
        .catch(externalCardAccountsErr => {
          commit('GET_EXTERNAL_CARD_ACCOUNTS', { status: 'failure', error: externalCardAccountsErr.message });
        });
    },
    async getExternalTransactions({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_EXTERNAL_CARD_TRANSACTION_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getExternalTransactionsData) => {
          let externalTransactionsList = {userExpenses:[]};
          getExternalTransactionsData.data.userExpenses.forEach((externalTransaction) => {
            if(externalTransaction.accountingTransactionTempBackup
              && externalTransaction.accountingTransactionTempBackup.companyId === payload.companyId) {                
                externalTransaction.accountingTransactionTempBackup.receivingCompanyName = externalTransaction.Company.companyName;
                externalTransaction.accountingTransaction = externalTransaction.accountingTransactionTempBackup;
                if(externalTransaction.accountingTransactionTempBackup.category) {
                  externalTransaction.category = {categoryName: externalTransaction.accountingTransactionTempBackup.category.categoryName};
                }
                externalTransactionsList.userExpenses.push(externalTransaction);
            } else {
              externalTransaction.accountingTransactionTempBackup = null;
              if(externalTransaction.recordStatus !== 9
                && externalTransaction.category
                && externalTransaction.category.accountingCategory
                ) {
                externalTransactionsList.userExpenses.push(externalTransaction);
              }
              if(externalTransaction.recordStatus === 9 && externalTransaction.accountingTransaction) {
                externalTransactionsList.userExpenses.push(externalTransaction);
              }
            }
          });
          commit('GET_EXTERNAL_CARD_TRANSACTIONS', externalTransactionsList);
        })
        .catch(getExternalTransactionserr => {
          console.log(getExternalTransactionserr);
        });
    },

    async getSelectedPayabledAccount({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_SELECTED_PAYABLE_ACCOUNT_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getSelectedPayabledAccountData) => {
          commit('GET_SELECTED_PAYABLE_ACCOUNT', getSelectedPayabledAccountData.data.getSelectedPayabledAccount);
        })
        .catch(getSelectedPayabledAccountErr => {
          commit('GET_SELECTED_PAYABLE_ACCOUNT', { status: 'failure', error: getSelectedPayabledAccountErr.message });
        });
    },
    async getTeamsForMapping({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_TEAMS_FOR_MAPPING_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getTeamsForMappingData) => {
          if (getTeamsForMappingData.data.groups.length > 0) {
            getTeamsForMappingData.data.groups.forEach((team, index) => {
              getTeamsForMappingData.data.groups[index].agilLinkLevel1Id = null;
              getTeamsForMappingData.data.groups[index].accountingTeamTableId = null;
              if (team.accountingTeam) {
                getTeamsForMappingData.data.groups[index].accountingTeamTableId = team.accountingTeam.id;
                if (team.accountingTeam.agilLinkOnline) {
                  getTeamsForMappingData.data.groups[index].agilLinkLevel1Id = team.accountingTeam.teamId;
                }
              }
            });
          }
          getTeamsForMappingData.data.groups = getTeamsForMappingData.data.groups.sort((a, b) => a.recordStatus - b.recordStatus);
          commit('GET_TEAMS_FOR_MAPPING', { uniqueId: moment.now(), teams: getTeamsForMappingData.data.groups });
        })
        .catch(getTeamsForMappingErr => {
          commit('GET_TEAMS_FOR_MAPPING', { status: 'failure', error: getTeamsForMappingErr.message });
        });
    },
    async storeAccountingTeams({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: SET_STORE_ACCOUNTING_TEAMS_GQL,
          variables: payload,
        })
        .then((storeAccountingTeamsData) => {
          commit('SET_STORE_ACCOUNTING_TEAMS', storeAccountingTeamsData.data.storeAccountingTeams);
        })
        .catch(storeAccountingTeamsErr => {
          commit('SET_STORE_ACCOUNTING_TEAMS', { status: 'failure', error: storeAccountingTeamsErr.message });
        });
    },
    async storeAccountingTags({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: SET_STORE_ACCOUNTING_TAGS_GQL,
          variables: payload,
        })
        .then((storeAccountingTagsData) => {
          commit('SET_STORE_ACCOUNTING_TAGS', storeAccountingTagsData.data.storeAccountingTags);
        })
        .catch(storeAccountingTagsErr => {
          commit('SET_STORE_ACCOUNTING_TAGS', { status: 'failure', error: storeAccountingTagsErr.message });
        });
    },
     // stores sync frequency value in database
     async storeTransactionSyncFrequency({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: SET_STORE_TRANSACTION_SYNC_FREQUENCY_GQL,
          variables: payload,
        })
        .then((storeTransactionSyncFrequencyData) => {
          if(storeTransactionSyncFrequencyData.data.storeTransactionSyncFrequency.status === 'success') {
            commit('GET_TRANSACTION_SYNC_FREQUENCY_VALUE', {status: "success", data: JSON.stringify(payload.transactionSyncFrequency)});
          }
          commit('SET_STORE_TRANSACTION_SYNC_FREQUENCY', storeTransactionSyncFrequencyData.data.storeTransactionSyncFrequency);
        })
        .catch(storeTransactionSyncFrequencyErr => {
          commit('SET_STORE_TRANSACTION_SYNC_FREQUENCY', { status: 'failure', error: storeTransactionSyncFrequencyErr.message });
        });
    },
    async getTransactionSyncFrequencyValue({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_TRANSACTION_SYNC_FREQUENCY_VALUE_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getTransactionSyncFrequencyValueData) => {
          commit('GET_TRANSACTION_SYNC_FREQUENCY_VALUE', getTransactionSyncFrequencyValueData.data.getTransactionSyncFrequencyValue);
        })
        .catch(getTransactionSyncFrequencyValueErr => {
          commit('GET_TRANSACTION_SYNC_FREQUENCY_VALUE', { status: 'failure', error: getTransactionSyncFrequencyValueErr.message });
        });
    },
    async getSyncTransactionHistory({commit}, payload) {
      await apolloClient
        .query({
          query: GET_SYNC_TRANSACTION_HISTORY_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getSyncTransactionHistoryData) => {
          commit('GET_SYNC_TRANSACTION_HISTORY', getSyncTransactionHistoryData.data.getSyncTransactionHistory);
        })
        .catch(getSyncTransactionHistoryErr => {
          commit('GET_SYNC_TRANSACTION_HISTORY', { status: 'failure', error: getSyncTransactionHistoryErr.message });
        });
    },
    async checkPreviousOperationStatus({commit}, payload) {
      await apolloClient
        .query({
          query: GET_CHECK_PREVIOUS_OPERATION_STATUS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((checkPreviousOperationStatusData) => {
          commit('GET_CHECK_PREVIOUS_OPERATION_STATUS', checkPreviousOperationStatusData.data.checkPreviousOperationStatus);
        })
        .catch(checkPreviousOperationStatusErr => {
          commit('GET_CHECK_PREVIOUS_OPERATION_STATUS', { status: 'failure', error: checkPreviousOperationStatusErr.message });
        });
    },
    async getClusteredCompaniesList({commit}, payload) {
      await apolloClient
        .query({
          query: GET_CLUSTERED_COMPANIES_LIST_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
      .then((getClusteredCompaniesListData) => {
        commit('GET_CLUSTERED_COMPANIES_LIST', getClusteredCompaniesListData.data.getClusteredCompaniesList);
      })
      .catch(getClusteredCompaniesListErr => {
        commit('GET_CLUSTERED_COMPANIES_LIST', { status: 'failure', error: getClusteredCompaniesListErr.message });
      });
    },    
    // Stores due from & to accounts mapping in database
    async storeDueAccountsMapping({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: SET_STORE_DUE_ACCOUNTS_MAPPING_GQL,
          variables: payload,
        })
      .then((storeDueAccountsMappingData) => {          
        commit('SET_STORE_DUE_ACCOUNTS_MAPPING', storeDueAccountsMappingData.data.storeDueAccountsMapping);
      })
      .catch(storeDueAccountsMappingErr => {
        commit('SET_STORE_DUE_ACCOUNTS_MAPPING', { status: 'failure', error: storeDueAccountsMappingErr.message });
      });
    },
    async getAssetsLiabilitiesList({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_ASSETS_LIABILITIES_LIST_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
      .then((getAssetsLiabilitiesListData) => {
        commit('GET_ASSETS_LIABILITIES_LIST', getAssetsLiabilitiesListData.data.getAssetsLiabilitiesList);
      })
      .catch(getAssetsLiabilitiesListErr => {
        commit('GET_ASSETS_LIABILITIES_LIST', { status: 'failure', error: getAssetsLiabilitiesListErr.message });
      });
    },
    async getDueAccountMapping({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_DUE_ACCOUNT_MAPPING_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
      .then((getDueAccountMappingData) => {
        commit('GET_DUE_ACCOUNT_MAPPING', getDueAccountMappingData.data.getDueAccountMapping);
      })
      .catch(getDueAccountMappingErr => {
        commit('GET_DUE_ACCOUNT_MAPPING', { status: 'failure', error: getDueAccountMappingErr.message });
      });
    },
    // Gets data from accountingLiability table
    async getAccountingLiability({commit}, payload) {
      await apolloClient
        .query({
          query: GET_ACCOUNTING_LIABILITY_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
      .then((getAccountingLiabilityData) => {
        console.log('getAccountingLiabilityData', getAccountingLiabilityData);
        commit('GET_ACCOUNTING_LIABILITY', getAccountingLiabilityData.data.getAccountingLiability);
      })
      .catch(getAccountingLiabilityErr => {
        commit('GET_ACCOUNTING_LIABILITY', { status: 'failure', error: getAccountingLiabilityErr.message });
      });
    },
    async getMovedTransactions({commit}, payload) {
      await apolloClient
        .query({
          query: GET_MOVED_TRANSACTIONS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
      .then((getMovedTransactionsData) => {
        commit('GET_MOVED_TRANSACTIONS', getMovedTransactionsData.data.getMovedTransactions);
      })
      .catch(getMovedTransactionsErr => {
        commit('GET_MOVED_TRANSACTIONS', { status: 'failure', error: getMovedTransactionsErr.message });
      });
    } 
  },

  getters: {
    teamWiseCategoryList: state => state.teamWiseCategoryList,
    accountingCategoriesStore: state => state.accountingCategoriesStore,
    accountingCategoryList: state => state.accountingCategoryList,
    activeAccountingSys: state => state.activeAccountingSys,
    accountingSysDisConnected: state => state.accountingSysDisConnected,
    updatedMappedCategories: state => state.updatedMappedCategories,
    clearedTransactions: state => state.clearedTransactions,
    selectedCreditCardAccount: state => state.selectedCreditCardAccount,
    selectedBankAccount: state => state.selectedBankAccount,
    clearedBankTransactions: state => state.clearedBankTransactions,
    externalCreditCardAccounts: state => state.externalCreditCardAccounts,
    selectedPayableAccount: state => state.selectedPayableAccount,
    accountingTags: state => state.accountingTags,
    accountingTeams: state => state.accountingTeams,
    updatedMappedTags: state => state.updatedMappedTags,
    teamsForMapping: state => state.teamsForMapping,
    updatedMappedTeams: state => state.updatedMappedTeams,
    accountingTeamsStore: state => state.accountingTeamsStore,
    accountingTagsStore: state => state.accountingTagsStore,
    transactionSyncFrequencyStored: state => state.transactionSyncFrequencyStored,
    transactionSyncFrequencyValue: state => state.transactionSyncFrequencyValue,
    syncedTransactionHistory: state => state.syncedTransactionHistory,
    previousOperationStatus: state => state.previousOperationStatus,
    clusteredCompaniesList: state => state.clusteredCompaniesList,
    storedDueAccountsMapping: state => state.storedDueAccountsMapping,
    assetsLiabilitiesList: state => state.assetsLiabilitiesList,
    dueAccountMapping: state => state.dueAccountMapping,
    accountingLiabilityList: state => state.accountingLiabilityList,
    movedTransactionsList: state => state.movedTransactionsList,
  },
};
